import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimBookingResponse extends BaseModel {
    @Expose() id = 0;
    @Expose() createdDate = "";
}
